import { MutableRefObject } from 'react';
import GameEngine from 'react-game-engine';

import { Dim, Entity } from '../../models';
import Exit from '../renderers/Exit';
import { getNoteDims } from '../../helpers';

export default (
  windowDims: Dim,
  redirect: string,
  gameEngineRef: MutableRefObject<GameEngine>
): Entity => {
  const noteDims = getNoteDims(windowDims);

  return {
    dims: {
      w: noteDims.w,
      h: noteDims.w,
      b: noteDims.w / 1.5,
      m: noteDims.w / 4,
    },
    getPos: () => ({ x: windowDims.w, y: 0 }),
    redirect,
    gameEngineRef,
    renderer: Exit,
  };
};
